<template>
    <div class="module">
        <header class="module__header">
            <a
                class="back-btn"
                @click="goBack('app-repository')"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">{{ appName }}</h1>
        </header>

        <section class="module__body">
            <index-table
                :cols="columns"
                :title="'App Report'"
                :model="`app-repository/${id}/downloads`"
                :defaultSort="`organization_id`"
                :defaultDir="sortDir"
                data-test-id="app-repo-downloads-table"
            />
        </section>
    </div>
</template>

<script>
import hasBackButton from '@/mixins/hasBackButton'
import IndexTable from '@/components/IndexTable/index.vue'
import SortDirections from '@/constants/sort-directions'

export default {
    components: { IndexTable },

    mixins: [hasBackButton],

    data() {
        return {
            app: null,
            id: this.$route.params.id,
            sortDir: SortDirections.DESC,
            columns: [
                {
                    value: 'organization',
                    label: 'Organization',
                    sortable: true,
                    searchable: true,
                    display: 'name',
                },
                {
                    value: 'enabled',
                    label: 'Enabled App',
                    sortable: true,
                    searchable: false,
                },
                {
                    value: 'download_count',
                    label: 'Number of Downloads',
                    sortable: true,
                    searchable: false,
                },
            ],
        }
    },

    computed: {
        appName() {
            return this.app !== null ? this.app.display_name : ''
        },
    },

    mounted() {
        this.$http.get(`/app-repository/${this.$route.params.id}`).then(({ data }) => {
            this.app = data
        })
    },

    methods: {},
}
</script>
